<template>
  <div class="col-xl-6 col-lg-4 col-sm-12">
    <div class="mb-3">
      <label>Tipo de evento<span class="text-danger">*</span></label>
      <vee-field
        as="select"
        :name="fieldName"
        class="form-select"
        v-model="selectedKind"
      >
        <option value="" selected disabled>Seleccione una opción</option>
        <option v-for="kind in activeKinds" :value="kind.id" :key="kind.id">
          {{ kind.name }}
        </option>
      </vee-field>
      <ErrorMessage class="text-danger" :name="fieldName" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";

const props = defineProps({
  kinds: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: [String, Number],
    default: "",
  },
  fieldName: {
    type: String,
    default: "kind_event_code",
  },
});

const emit = defineEmits(["update:modelValue", "type-change"]);

const selectedKind = ref(props.modelValue);

const activeKinds = computed(() => {
  return props.kinds.filter((kind) => kind.state !== false);
});

const selectedKindData = computed(() => {
  if (!selectedKind.value) return null;
  return props.kinds.find((k) => k.id == selectedKind.value);
});

const eventType = computed(() => {
  if (!selectedKindData.value) return null;
  return selectedKindData.value.name;
});

const kindName = computed(() => {
  return eventType.value;
});

const isVirtual = computed(() => {
  return kindName.value === "VIRTUAL";
});

const isPresencial = computed(() => {
  return kindName.value === "PRESENCIAL";
});

const isHybrid = computed(() => {
  return kindName.value === "PRESENCIAL-VIRTUAL";
});

watch(selectedKind, (newVal) => {
  emit("update:modelValue", newVal);
  const dataToEmit = {
    id: newVal,
    name: eventType.value,
    isVirtual: isVirtual.value,
    isPresencial: isPresencial.value,
    isHybrid: isHybrid.value,
  };

  if (!newVal) {
    dataToEmit.name = "";
    dataToEmit.isVirtual = false;
    dataToEmit.isPresencial = false;
    dataToEmit.isHybrid = false;
  }
  emit("type-change", dataToEmit);
});

watch(
  () => props.modelValue,
  (newVal) => {
    selectedKind.value = newVal;
  },
  { immediate: true }
);

const clearSelection = () => {
  selectedKind.value = "";
};

defineExpose({
  clearSelection,
  isVirtual,
  isPresencial,
  isHybrid,
  eventType,
});
</script>
